import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from './components/home-page/HelloWorld.vue';
import FAQPage from './components/informational-pages/FAQPage.vue';
import ContactPage from './components/informational-pages/ContactPage.vue';
import AccountPage from './components/account-page/AccountPage.vue';
import PrivacyPolicyPage from './components/informational-pages/PrivacyPolicyPage.vue';
import TermsPage from './components/informational-pages/TermsPage.vue';
import TipsForSuccessPage from './components/account-page/TipsForSuccessPage.vue';
import UnsubscribePage from './components/informational-pages/UnsubscribePage.vue';
import AboutMePage from './components/informational-pages/AboutMePage.vue';
import { buildApiUrl } from './config/api';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQPage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/account',
    name: 'Account',
    component: AccountPage
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsPage
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage
  },
  {
    path: '/tips-for-success',
    name: 'TipsForSuccess',
    component: TipsForSuccessPage
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: UnsubscribePage
  },
  {
    path: '/about-me',
    name: 'AboutMe',
    component: AboutMePage
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Navigation guard to protect authenticated routes
router.beforeEach(async (to, from, next) => {
  // Check if the route requires authentication
  if (to.path === '/account') {
    try {
      // Use the API utility to get the correct endpoint
      const response = await fetch(buildApiUrl('/getAccount'), {
        method: 'GET',
        credentials: 'include', // Send httpOnly cookies
      });
      if (response.ok) {
        // Authenticated, allow navigation
        next();
      } else {
        // Not authenticated, redirect to home with prompt to log in
        next({ path: '/', query: { login: 'required', redirect: to.fullPath } });
      }
    } catch (err) {
      // On error, redirect to home with prompt to log in
      next({ path: '/', query: { login: 'required', redirect: to.fullPath } });
    }
  } else {
    // Route doesn't require authentication, allow navigation
    next();
  }
});

export default router;
